import { defineStore } from 'pinia'
import { computed, ref } from 'vue'

import type { DropdownOption } from '@/components/common/ui/inputs/inputTypes'
import type { RelationType } from '@/constants/relations'
import type { RatingReponse } from '@/types/external/2work/api/response/RatingResponse'

import { useFrappeNestCustomAPIStore } from '@/stores/apis/frappeNestCustomAPI'
import { translationFunctionDefault } from '@/utilities/translations'

const useRatingStore = defineStore('RatingStore', () => {
  const customAPIStore = useFrappeNestCustomAPIStore()
  const tfDefault = translationFunctionDefault()

  const ratings = ref<RatingReponse[]>([])

  const ratingsOptions = computed(() => {
    const ratingNotSet: DropdownOption<string> = {
      isPlaceholderOption: true,
      optionLabel: tfDefault('ratings.noRating'),
      optionValue: '',
    }
    const fetchedRatings = ratings.value.map((rating) => {
      const mapDropdownOption: DropdownOption<string> = {
        optionLabel: rating.translated_tw_rating_name ?? rating.tw_rating_name,
        optionValue: rating.name,
      }

      return mapDropdownOption
    })

    return [ratingNotSet, ...fetchedRatings]
  })

  const fetchRatingsByDoctype = async (doctype: RelationType): Promise<void> => {
    const newRatingList = await customAPIStore.updateRatingsByDoctype({
      sub_type: doctype,
    })

    ratings.value = newRatingList
  }

  return {
    fetchRatingsByDoctype,
    ratingsOptions,
  }
})

export { useRatingStore }
